(function () {
  'use strict';

  /*
   * These are the sections that should be opened in ReportBuilder if
   * there is a particular invalid config property. So for example, if
   * a bar chart has an error it will open the 'bar-chart' section of
   * the report builder.
   */
  var reportConfigSectionNames = {
    "range": "range-chart",
    "bar": "bar-chart",
    "correlation": "correlation",
    "activity": "activities",
    "leaderboard": "lister",
    "heatmap": "heatmap",
    "line": "line-chart",
    "scatter": "scatter-plot",
    "spider": "spider",
    "pie-chart": "pie-chart",
    "metric": "metric"
  };

  // Default validator ensures we have at least one measure
  function defaultValidation(section, config) {
    var minMeasures = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var error = {
      hasErrors: true,
      section: section
    };
    if (!config.measures || config.measures.length < minMeasures) {
      var message = "Please select at least ".concat(minMeasures, " measure");
      return Object.assign(error, {
        message: message
      });
    } else if (!config.dimensions || !config.dimensions.length) {
      var _message = 'Please specify a dimension';
      return Object.assign(error, {
        message: _message
      });
    }
    return {
      hasErrors: false
    };
  }
  angular.module('wsLrs.cards').factory('ReportValidationService', ['Utils', 'Logger', 'range-chart.Utils', 'CardRegistry', function (Utils, Logger, RangeUtils, CardRegistry) {
    return {
      validate: function validate(cardId) {
        if (!cardId) {
          throw new Error("No card ID was provided to the validation function!");
        }
        var card = CardRegistry.get(cardId);
        if (!card) {
          throw new Error("No card could be found for ID: ".concat(cardId));
        }
        var type = Utils._try(function () {
          return card.template.name.toLowerCase();
        }, null);
        if (!type) {
          throw new Error("Could not find a template type for card template: ".concat(card.template));
        }
        var config = card.configuration;
        if (!config) {
          throw new Error("Could not find configuration for card while validating");
        }
        var section = reportConfigSectionNames[type];
        var error = {
          hasErrors: true,
          section: section
        };
        var defaultErrors = defaultValidation(section, config);
        switch (type) {
          case 'pie-chart':
          case 'leaderboard':
          case 'heatmap':
          case 'line':
          case 'bar':
            return defaultErrors;
          case 'correlation':
            return defaultValidation(section, config, 2);
          case 'range':
            if (defaultErrors.hasErrors) {
              return defaultErrors;
            }
            if (!config.measures.length || config.measures.length <= 1) {
              var message = 'Please select more than 1 measure';
              return Object.assign(error, {
                message: message
              });
            } else if (config.measures.length % 2 !== 0) {
              var _message2 = 'Please select an even number of measures';
              var anchor = 'measure-selector';
              return Object.assign(error, {
                message: _message2,
                anchor: anchor
              });
            } else if (!RangeUtils.areMeasuresCompatible(config.measures)) {
              var _message3 = 'Please select 2 measures with the same data type';
              return Object.assign(error, {
                message: _message3
              });
            }
            return {
              hasErrors: false
            };
          case 'activity':
            if (!config.filter || !config.filter.activityIds || !config.filter.activityIds.ids || config.filter.activityIds.ids.length < 1) {
              var _message4 = 'Please select at least one activity';
              return Object.assign(error, {
                message: _message4
              });
            }
            return {
              hasErrors: false
            };
          case 'scatter':
            if (defaultErrors.hasErrors) {
              return defaultErrors;
            }
            if (!config.measures || config.hiddenMeasures ? config.measures.length - config.hiddenMeasures.length !== 2 : config.measures.length !== 2) {
              var _message5 = 'Please select 2 measures';
              return Object.assign(error, {
                message: _message5
              });
            }
            return {
              hasErrors: false
            };
          case 'spider':
            if (defaultErrors.hasErrors) {
              return defaultErrors;
            }
            if (!config.measures || config.measures.length < 3) {
              var _message6 = 'Please select at least 3 measures';
              return Object.assign(error, {
                message: _message6
              });
            } else if (config.overlay && (!config.overlay.measures || config.overlay.measures.length !== config.measures.length)) {
              var _message7 = 'Please select the same number of measures for the overlay as the card';
              return Object.assign(error, {
                message: _message7
              });
            }
            return {
              hasErrors: false
            };
          case 'metric':
            if (!config.dimensions || !config.dimensions.length) {
              var _message8 = 'Please specify a dimension';
              return Object.assign(error, {
                message: _message8
              });
            }
            return {
              hasErrors: false
            };
          default:
            return {
              hasErrors: false
            };
        }
      }
    };
  }]);
})();
